let loadingCount = 0;
const openLoading = window.ZZCFL.Loading.open;
const closeLoading = window.ZZCFL.Loading.close;

window.ZZCFL.Loading.open = params => {
    loadingCount++;
    return openLoading(params);
};

window.ZZCFL.Loading.close = params => {
    loadingCount--;
    if (loadingCount > 0) {
        return;
    }
    return closeLoading(params);
};
